import { createFormData } from 'src/helpers';
import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUpdateMenuSetRequest, IUpdateMenuSetResponseBody } from './types';

export const updateMenuSet = async (
  menuSetId: string,
  payload: IUpdateMenuSetRequest,
): Promise<IUpdateMenuSetResponseBody> => {
  const res = await fetch(`${API_URL}/menus/menu-sets/${menuSetId}`, {
    method: 'PATCH',
    body: createFormData(payload),
  });

  if (!res.ok) {
    let errorBody: { message?: string } | null;
    try {
      errorBody = await res.json();
    } catch {
      errorBody = null;
    }
    throw new Error(errorBody?.message || res.statusText);
  }

  return res.json();
};
